import { render, staticRenderFns } from "./ups.vue?vue&type=template&id=02e3b5ca&scoped=true&"
import script from "./ups.vue?vue&type=script&lang=js&"
export * from "./ups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e3b5ca",
  null
  
)

export default component.exports